import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type CenterActionsType = {
  canViewCenterActivitiesAndBudget: boolean
  canUpdateAccomodation: boolean
  canUnblockCosts: boolean
}

export function getCenterActions(id: number): Promise<CenterActionsType> {
  return restApiClient
    .url(constructApiUrl(API.centers.getActions.url, { id }))
    .get<CenterActionsType>()
}
